import "./GarageDoorRepairCentralCoast.module.css";
import Header from "@/reusable_sections/Header";
import LocationHero from "./sections/LocationHero";
import Services from "./sections/Services";
import Centralcoastservices from "./sections/Centralcoastservices";
import Partnerships from "./sections/Partnerships";
import ServiceProcess from "./sections/ServiceProcess";
import WhyChooseUs from "./sections/WhyChooseUs";
import Serviceareas from "./sections/Serviceareas";
import Testimonials from "./sections/Testimonials";
import Faq from "./sections/Faq";
import CallToActionContact from "./sections/CallToActionContact";
import SiteFooter from "./sections/SiteFooter";
export default function GarageDoorRepairCentralCoastPage() {
  return <div>
      <Header />
      <LocationHero />
      <Services />
      <Centralcoastservices />
      <Partnerships />
      <ServiceProcess />
      <WhyChooseUs />
      <Serviceareas />
      <Testimonials />
      <Faq />
      <CallToActionContact />
      <SiteFooter />
    </div>;
}